export const DECIMAL_SCALE = 9;
export const MINIMUM_SUPPORTED_NUM = 10 ** -DECIMAL_SCALE;
